import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Function to show error toast
export function showToastErrorMsg(errMsg, toastId = 'error') {
  // Dismiss any existing toast with the same ID
  toast.dismiss(toastId);
  
  toast.error(errMsg, {
    position: "top-right",
    className: "toast-message",
    autoClose: 5000,
    toastId: toastId,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  });
}

// Function to show success toast
export function showToastSuccessMsg(successMsg, toastId = 'success') {
  // Dismiss any existing toast with the same ID
  toast.dismiss(toastId);
  
  toast.success(successMsg, {
    position: "top-right",
    className: "toast-message",
    autoClose: 3000,
    toastId: toastId,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  });
}
